import { useFieldArray, useFormContext } from "react-hook-form";
import { IUser } from "../../../types/Auth/user";
import { inventoryPermissionValue } from "../../../utils/Permission/Inventory";
import PermissionTable from "./PermissionTable";

const InventoryPermissionTable = () => {
  const { control, watch } = useFormContext<IUser>();
  const { fields, replace } = useFieldArray({
    control,
    name: "inventory_permission",
    keyName: "genId",
  });

  const watchFieldArray = watch("inventory_permission");

  const controlledFields = fields.map((field, index) => {
    return {
      ...field,
      ...(watchFieldArray &&
        watchFieldArray.length > 0 &&
        watchFieldArray[index]),
    };
  });

  const resetArrayHandler = () => {
    replace(inventoryPermissionValue);
  };

  return (
    <PermissionTable
      module={"inventory_permission"}
      controlledFields={controlledFields}
      resetArrayHandler={resetArrayHandler}
    />
  );
};

export default InventoryPermissionTable;
